import { useEffect, useState } from "react";

const BREAKPOINT_TOKEN = "--tc-breakpoint-md";

/** Used only if the design-token stylesheet has not resolved yet. */
const BREAKPOINT_FALLBACK = "48rem";

function readMdBreakpoint(): string {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(BREAKPOINT_TOKEN)
    .trim();

  return value === "" ? BREAKPOINT_FALLBACK : value;
}

/**
 * True below the md breakpoint. Drives the sidebar's auto-collapse to the icon
 * rail.
 *
 * The breakpoint comes from `--tc-breakpoint-md` rather than a literal, so it
 * stays in step with the TC token and the `md:` Tailwind variants. Media queries
 * cannot use `var()`, so the value is read from the resolved custom property and
 * interpolated into the query string.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // `not all and (min-width: X)` is the exact complement of a `min-width: X`
    // rule, so there is no off-by-one pixel fudge and the unit (rem or px) does
    // not need converting.
    const query = window.matchMedia(`not all and (min-width: ${readMdBreakpoint()})`);

    const handleChange = (): void => {
      setIsMobile(query.matches);
    };

    handleChange();
    query.addEventListener("change", handleChange);

    return () => {
      query.removeEventListener("change", handleChange);
    };
  }, []);

  return isMobile;
}
